var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.groups),function(group){return _c('li',{key:(group + "-nav")},[_c('a',{attrs:{"href":("#" + group)}},[_vm._v(_vm._s(group))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }